import querystring from 'querystring'
// import Logger from '../log/Logger'

class Connection {
  /**
   * @name Connection#httpClient
   * @type {object}
   */

  /**
   * @name Connection#apiUrl
   * @type {string}
   */

  /**
   * @name Connection#logger
   * @type {object}
   */

  /**
   * @name Connection#clientCode
   * @type {string}
   */

  /**
   * @name Connection#sessionKey
   * @type {string}
   */

  /**
   * @name Connection#partnerKey
   * @type {string}
   */

  /**
   * @name Connection#maxRequestsPerSecond
   * @type {int}
   */

  /**
   * @name Connection#nextRequestEarliestStart
   * @type {int}
   */

  constructor (httpClient, apiUrl, partnerKey = '', debugLogEnabled = false, promotionRuleToken) {
    this.httpClient = httpClient
    this.apiUrl = apiUrl
    this.clientCode = ''
    this.sessionKey = ''
    this.partnerKey = partnerKey
    this.promotionRuleToken = promotionRuleToken
    this.maxRequestsPerSecond = 5
    this.nextRequestEarliestStart = Date.now()

    if (debugLogEnabled) {
      this.setLogger(console)
    }
  }

  setLogger (logger) {
    this.logger = logger
  }

  log (toLog) {
    if (this.logger) {
      this.logger.log(toLog)
    }
  }

  openSession (clientCode, sessionKey) {
    this.clientCode = clientCode
    this.sessionKey = sessionKey
  }

  url () {
    if (this.clientCode === '') {
      throw Error('Session not opened')
    }

    return this.apiUrl
  }

  addAuthParams (data) {
    data.partnerKey = this.partnerKey

    if (data.request === 'verifyUser') {
      return data
    }

    if (this.sessionKey === '') {
      throw Error('Session not opened')
    }

    data.sessionKey = this.sessionKey
    data.clientCode = this.clientCode

    return data
  }

  scheduleRequest (request) {
    let minRequestInterval = 1000 / this.maxRequestsPerSecond
    if (this.nextRequestEarliestStart <= Date.now()) {
      this.nextRequestEarliestStart = Date.now() + minRequestInterval
      return request()
    }

    let timeout = this.nextRequestEarliestStart - Date.now()

    let promise = new Promise(resolve => {
      setTimeout(() => resolve(request()), timeout)
    })

    this.nextRequestEarliestStart = this.nextRequestEarliestStart + minRequestInterval
    return promise
  }

  getSpeaHeaders () {
    return {
      'Erply-Api-Clientcode': this.clientCode,
      'Erply-Api-Sessionkey': this.sessionKey,
      'Erply-Api-Partnerkey': this.partnerKey,
      'PromotionRule-Api-Token': this.promotionRuleToken,
      'Content-Type': 'application/json'
    }
  }

  get (request, parameters) {
    try {
      this.log('Sending get request to ' + this.url())
      this.log(parameters)
      parameters = querystring.stringify(parameters)

      let options = {}
      options.headers = this.getSpeaHeaders()

      request = (parameters) ? (request + '?' + parameters) : request
      return this.scheduleRequest(() => this.httpClient.get(this.url() + request, options))
        .then(response => {
          //console.log("aaa1")
          this.log('Got get response')
          this.log(response)

          return response
        }).then(response => this.assertResponseSuccess(response))
        .catch((error) => {
         // console.log("aaa3")
          this.log('Got error during get request')
          this.log(error)
          //Vue.emitTemporaryProblemEvent()
          //return Promise.reject(error)
          return null
        });
    } catch (error) {
     // console.log("aaa2")
      this.log('Got error during get request')
      this.log(error)

      return Promise.reject(error)
    }
  }

  async requestSpea (request, data) {
    try {
      this.log('Sending request to SPEA to ' + this.url())
      this.log(data)

      let options = {}
      options.headers = this.getSpeaHeaders()

      return this.scheduleRequest(() => {
        if (data.mode === 'post') {
          return this.httpClient.post(this.url() + request, data, options)
        } else if (data.mode === 'patch') {
          return this.httpClient.patch(this.url() + request, data, options)
        } else if (data.mode === 'delete') {
          return this.httpClient.delete(this.url() + request, options)
        }
      }).then(response => {
        this.log('Got response from SPEA')
        this.log(response)

        return response//this.assertResponseSuccess(response)//response
      })
      .then(response => this.assertResponseSuccess(response))
        .catch((error) => {
          // console.log("aaa3")
          this.log('Got error during SPEA request')
          this.log(error)
          //Vue.emitTemporaryProblemEvent()
          //return Promise.reject(error)
          return null
        });
    } catch (error) {
      this.log('Got error during posting')
      this.log(error)

      return Promise.reject(error)
    }
  }

  postErply (data) {
    try {
      data = this.addAuthParams(data)
      data = querystring.stringify(data)

      let urlToErply = 'https://' + this.clientCode + '.erply.com/api/'
      // let urlToErply = 'http://127.0.0.1:9008/api/'
      this.log('Sending post request to Erply to ' + urlToErply)
      this.log(data)

      let options = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      return this.scheduleRequest(() => this.httpClient.post(urlToErply, data, options))
        .then(response => {
          this.log('Got post response')
          this.log(response)

          return response
        })
        .then(response => this.assertResponseSuccess(response))
    } catch (error) {
      this.log('Got error during posting')
      this.log(error)

      return Promise.reject(error)
    }
  }

  assertResponseSuccess (response) {
    //console.log('assertResponseSuccess')
    //console.log(response)
    if (
      typeof response.status === 'undefined' ||
      typeof response.statusText === 'undefined'
    ) {
      //console.log('SPEA reject 1')
      return Promise.reject(response)
    } else if (response.status < 200 || response.status >= 400) {
      //console.log('SPEA reject 2')
      return Promise.reject(response)
    }
    //console.log('SPEA resolve')
    return Promise.resolve(response)
  }
}
export default Connection



// WEBPACK FOOTER //
// ./src/api/Connection.js